/**
 * 配貨商品匹配邏輯
 *
 * 從 DistributeContext 提取的純函數，方便單元測試
 */

/**
 * 在 fulfillments 中匹配商品
 * 匹配順序：barcode → SKU → batch
 * 會跳過已配滿的 item，找第一個還需要該商品的 slot
 *
 * @param {string} code - 掃描的條碼
 * @param {Array} fulfillments - picking wave 的 fulfillments 資料
 * @param {Array} currentState - 目前的 distributeState（含配貨進度）
 * @returns {{ slotNumber: number, order_item_id: number, sku: string, matched_by: string } | null}
 */
export function matchProductInFulfillments(code, fulfillments, currentState) {
  // 建立快速查詢：slotNumber + order_item_id → distributed item
  const distributedMap = new Map();
  for (const cell of currentState) {
    for (const item of cell.distributed_items) {
      distributedMap.set(`${cell.slotNumber}_${item.order_item_id}`, item);
    }
  }

  // 檢查某個 item 是否還需要配貨
  const needsMore = (slotNumber, orderItemId, requiredQty) => {
    const distributed = distributedMap.get(`${slotNumber}_${orderItemId}`);
    if (!distributed) return true;
    return distributed.distributed_quantity < (requiredQty || distributed.required_quantity);
  };

  // 依序匹配：barcode → SKU → batch，跳過已配滿的
  const matchers = [
    (item, c) => item.barcode && item.barcode === c ? 'barcode' : null,
    (item, c) => item.sku === c ? 'sku' : null,
    (item, c) => item.batch && item.batch === c ? 'batch' : null,
  ];

  for (const matcher of matchers) {
    for (const fulfillment of fulfillments) {
      if (!fulfillment.slot_number) continue;

      for (const item of fulfillment.items || []) {
        const matchedBy = matcher(item, code);
        if (matchedBy && needsMore(fulfillment.slot_number, item.order_item_id, item.quantity)) {
          return {
            slotNumber: fulfillment.slot_number,
            order_item_id: item.order_item_id,
            sku: item.sku,
            matched_by: matchedBy
          };
        }
      }
    }
  }

  return null;
}
